const CONSTANTS = {
  SEARCH_ICON:
    "https://ik.manmatters.com/mosaic-wellness/image/upload/v1654068663/dochub/rx-writer/Group_2284.png",
  SEARCH_PLACEHOLDER: "Search Appointment"
};

export default CONSTANTS;
